import { render, staticRenderFns } from "./AccountRecord.vue?vue&type=template&id=13f1b830&scoped=true&"
import script from "./AccountRecord.vue?vue&type=script&lang=js&"
export * from "./AccountRecord.vue?vue&type=script&lang=js&"
import style0 from "./AccountRecord.vue?vue&type=style&index=0&id=13f1b830&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f1b830",
  null
  
)

export default component.exports